// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import styles from "../styles/resultQuestionary.module.css";

import { logoutUser } from "../logoutUser";
import { userLogged } from "../userLogged";
import { verifyUserPaid } from "../verifyUserPaid";
import { Menu } from "./Menu";

import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip, ResponsiveContainer } from 'recharts';
import axios from "axios";
import { urlAPI_Current } from "../config";

export function ProfileRadarChartByAdmin({ userId }) {
  const [userData, setUserData] = useState([]);
  const [userSkills, setUserSkills] = useState({
    inteligencia_emocional: 0,
    complexidade: 0,
    tomada_de_decisao: 0,
    criatividade: 0,
    pensamento_critico: 0,
    flexibilidade_cognitiva: 0,
    adaptabilidade: 0,
    colaboracao_em_equipe: 0,
    empatia: 0,
    relacao_com_o_medo: 0,
    agilidade: 0,
    inteligencia_relacional: 0
  });

  async function getUserLogged(){
      try {
        const responseSkills = await axios.post(`${urlAPI_Current}/getProfileByAdmin`, {
          selectedUserId: userId,
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        });
        
        if (responseSkills.data.success === true) {
          const userInfo = responseSkills.data.user;
          setUserData(userInfo);
          console.log("Usuário possui dados");
        } else {
          console.log("Usuário não possui dados");
          toast.error("Erro ao carregar dados do usuário");
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        toast.error("Erro ao carregar dados do usuário");
      }
  }

  const data = [
    { subject: 'Inteligência Emocional', P: userSkills.inteligencia_emocional || 0},
    { subject: 'Complexidade', P: userSkills.complexidade || 0},
    { subject: 'Tomada de Decisão', P: userSkills.tomada_de_decisao || 0},
    { subject: 'Criatividade', P: userSkills.criatividade || 0},
    { subject: 'Pensamento Crítico', P: userSkills.pensamento_critico || 0},
    { subject: 'Flexibilidade Cognitiva', P: userSkills.flexibilidade_cognitiva || 0},
    { subject: 'Adaptabilidade', P: userSkills.adaptabilidade || 0},
    { subject: 'Colaboração em Equipe', P: userSkills.colaboracao_em_equipe || 0},
    { subject: 'Empatia', P: userSkills.empatia || 0},
    { subject: 'Relação com o medo', P: userSkills.relacao_com_o_medo || 0},
    { subject: 'Agilidade', P: userSkills.agilidade || 0},
    { subject: 'Inteligência Relacional', P: userSkills.inteligencia_relacional || 0}
  ];

  async function getUserSkills(){
    try {
      const responseSkills = await axios.post(`${urlAPI_Current}/getSkillsByAdmin`, {
        selectedUserId: userId,
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
      });

      if(responseSkills && responseSkills.data.userSkills) {
        setUserSkills(responseSkills.data.userSkills);
        console.log("Habilidades carregadas:", responseSkills.data.userSkills);
      } else {
        console.log("Nenhuma habilidade encontrada");
        toast.error("Erro ao carregar habilidades");
      }
    } catch(err) {
      console.error("Erro ao buscar habilidades:", err);
      toast.error("Erro ao carregar habilidades");
    }
  }

  useEffect(() => {
    const loadData = async () => {
      await getUserLogged();
      await getUserSkills();
    };
    
    loadData();
  }, []);

  if (!userData || !userSkills) {
    return <div>Carregando dados...</div>;
  }

  return (
    <div id="RadarChart" className={styles.radarChart}>
      <div className={styles.chartContainer} style={{width: '100%', height: '400px'}}>
        <ResponsiveContainer>
          <RadarChart className={styles.chart} outerRadius="60%" data={data}>
            <PolarGrid gridType="circle" />
            <PolarAngleAxis dataKey="subject" tick={{fill: '#666', fontSize: 12}} />
            <PolarRadiusAxis angle={30} domain={[0, 10]} />
            <Radar 
              name={userData.nome || 'Habilidades'} 
              dataKey="P" 
              stroke="#4287f5" 
              fill="#8884d8" 
              fillOpacity={0.6}
              isAnimationActive={true}
            />
            <Tooltip />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.legendResults}>
        <p className={styles.chartSubtitle}>Resultado: </p>
        <ul>
          {data.map((item, index) => (
            <li key={index}>{item.subject}: {item.P}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}